// extracted by mini-css-extract-plugin
export default {"wrapper":"T1-z","play":"U1-z"};